module.exports = __webpack_public_path__ + "img/icon-office-features.b34722d4.svg";